import { z } from 'zod'

export const ssoConfigApiSchema = z
  .object({
    entity_id: z.string(),
    acs_url: z.string(),
    idp_entity_id: z.string().nullable().default(''),
    idp_sso_target_url: z.string().nullable().default(''),
    idp_x509cert: z.string().nullable().default(''),
    saml_login_only: z.boolean().default(false),
    disable_saml_auto_creation: z.boolean().default(false),
  })
  .transform((data) => {
    const {
      entity_id,
      acs_url,
      idp_entity_id,
      idp_sso_target_url,
      idp_x509cert,
      saml_login_only,
      disable_saml_auto_creation,
    } = data
    return {
      entityId: entity_id,
      acsUrl: acs_url,
      idpEntityId: idp_entity_id,
      idpSsoTargetUrl: idp_sso_target_url,
      idpX509Certificate: idp_x509cert,
      samlLoginOnly: saml_login_only,
      disableSamlAutoCreation: disable_saml_auto_creation,
    }
  })
  .describe('SSO Config Type')

export type SSOConfigTypeAPI = z.infer<typeof ssoConfigApiSchema>

export const postSSOConfigInputSchema = z
  .object({
    idpEntityId: z.string(),
    idpSsoTargetUrl: z.string(),
    idpX509Certificate: z.string(),
    samlLoginOnly: z.boolean(),
    disableSamlAutoCreation: z.boolean(),
  })
  .transform((data) => ({
    idp_entity_id: data.idpEntityId,
    idp_sso_target_url: data.idpSsoTargetUrl,
    idp_x509cert: data.idpX509Certificate,
    saml_login_only: data.samlLoginOnly,
    disable_saml_auto_creation: data.disableSamlAutoCreation,
  }))
